import React from 'react';

/** Stylized door graphic matching monitor door-card design comps. */
export default function MonitorDoorIcon() {
    return (
        <div className="monitor-door-card-v2__door-icon" aria-hidden>
            <div className="monitor-door-card-v2__door-panel monitor-door-card-v2__door-panel--top" />
            <div className="monitor-door-card-v2__door-panel monitor-door-card-v2__door-panel--bottom">
                <span className="monitor-door-card-v2__door-handle" />
            </div>
        </div>
    );
}
